module.exports = __webpack_public_path__ + "fonts/FuturaStd-Book.1a641dac.ttf";